module.exports = __webpack_public_path__ + "static/creative-thinking-institute-logo-a2d780886cd5952efd5137c08d123be8.svg";